<template>
  <div class="header_module" name="home" id="home">
    <div class="h_pot">
      <div class="h_logo">
        <div class="logo_cup" @click="openGate(1)">
          <img :src="enlogoSrc" alt="">
        </div>
      </div>
      <div class="h_items">
        <div class="h_item_gate" @click="openGate(1)">Home</div>
        <div class="h_item_sgate" @mouseenter="usMEvent(1)" @mouseleave="usMEvent(2)">
          <div @click="openGate(2)">About IAIC</div>
          <div v-if="isUs" class="h_son_us">
            <about-us></about-us>
          </div>
        </div>
        <div class="h_item_gate" @mouseenter="proMEvent(1)" @mouseleave="proMEvent(2)">
          <div @click="openGate(3)">Products</div>
          <div v-if="isProduct" class="hh_son_goods">
            <h-product></h-product>
          </div>
        </div>
        <div class="h_item_gate" @click="openGate(4)">News</div>
        <!-- <div class="h_item_gate" @click="openGate(5)">Join Us</div> -->
        <div class="h_item_gate" @click="openGate(6)">Bidding</div>
        <div class="h_item_gate">
          <a href="" target="_blank" :underline="false">
            <!-- <img :src="earth" alt="" width="22" height="22"> -->
            <span class="h_en">
              <i class="fa fa-globe fa-lg" aria-hidden="true"></i>
              中文
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import hProduct from './product';
import aboutUs from './aboutUs';
export default {
  data() {
    return {
      selectLng: 'zh-CN',
      enlogoSrc: '../../../../static/img/header/enlogo.png',
      earth: '../../../../static/img/header/ch.png',
      earthW: '../../../../static/img/header/earthg.png',
      isUs: false,
      isProduct: false
    };
  },
  components: {
    aboutUs,
    hProduct
  },
  methods: {
    changeLang() {
      this.$i18n.locale = this.selectLng;
    },
    openGate(num) {
      switch (parseInt(num)) {
        case 1: // 首页
          this.$router.push({ name: 'iaic2019en/home' });
          break;
        case 2: // 关于我们
          this.$router.push({
            name: 'iaic2019en/company',
            params: {
              sumType: '1'
            }
          });
          break;
        case 3: // 产品服务
          this.$router.push({ name: 'iaic2019en/product' });
          break;
        case 4: // 企业动态
          this.$router.push({ name: 'iaic2019en/news' });
          break;
        // case 5: // 诚聘英才
        //   this.$router.push({ name: 'iaic2019en/join' });
        //   break;
        case 6: // 招标采购
          this.$router.push({ name: 'iaic2019en/bidding' });
          break;
      }
    },
    usMEvent(proType) {
      if (proType === 1) this.isUs = true;
      else this.isUs = false;
    },
    proMEvent(proType) {
      if (proType === 1) this.isProduct = true;
      else this.isProduct = false;
    }
  }
};
</script>
<style  scoped>
.header_module {
  width: 100%;
  height: 80px;
  position: relative;
  background-color: #f9f9f9;
  z-index: 3;
  top: 0;
  left: 0;
}
.h_pot {
  width: 100%;
  margin: 0 auto;
  height: 80px;
  overflow: hidden;
}
.h_logo {
  float: left;
  width: 40%;
  height: 70px;
  line-height: 70px;
}
.logo_cup {
  width: 422px;
  margin: 0 auto;
  cursor: pointer;
}
.h_items {
  float: left;
  width: 60%;
  overflow: hidden;
  height: 80px;
  line-height: 80px;
}
.h_item_gate {
  text-align: center;
  float: left;
  font-size: 18px;
  color: #000;
  width: 100px;
  margin: 0 20px 0 0;
  cursor: pointer;
  height: 55px;
}
.h_item_gate:hover {
  border-bottom: 3px solid #00697f;
}
.h_item_sgate {
  text-align: center;
  float: left;
  font-size: 18px;
  color: #000;
  margin: 0 20px 0 0;
  width: 120px;
  cursor: pointer;
  height: 55px;
}
.h_item_sgate:hover {
  border-bottom: 3px solid #00697f;
}
img {
  vertical-align: middle;
}
.h_son_us {
  position: absolute;
  top: 60px;
  z-index: 16;
}
.hh_son_goods {
  position: absolute;
  top: 60px;
  z-index: 16;
}

.h_en {
  color: #000;
  padding-top: 2px;
}
.h_en:hover {
  cursor: pointer;
  color: #00697f;
}
</style>



// WEBPACK FOOTER //
// src/pages/enViews/header/header.vue